import { DEFAULT_VISIBILITY_MAP } from '../../../../constants/visibility';
import { SweepCanvas } from '../../../sweep-canvas/SweepCanvas';
import { CanvasMode } from '../../../sweep-canvas/canvas-types';
import { useFunnelMapElements } from '../../../funnel-map-canvas/useFunnelMapElements';
import noop from 'lodash/noop';
import { selectCrmOrgs } from '../../environments/environmentsReducer';
import { useSelector } from 'react-redux';
import { PreviewContainer } from './PreviewContainer';

export const FunnelMapPreview = ({
  funnelMap,
  sxProps,
  showPreviewBackground,
  fitViewTimeoutValue,
  canvasMode,
}: {
  funnelMap: FunnelMap;
  sxProps?: any;
  showPreviewBackground?: boolean;
  fitViewTimeoutValue?: number;
  canvasMode?: CanvasMode;
}) => {
  const crmOrgs = useSelector(selectCrmOrgs);

  const {
    sweepNodes,
    sweepEdges,
    sweepGroups,
    sweepStandaloneNodes,
    sweepSections,
    sweepStickyNotesNodes,
    sweepTextNodes,
  } = useFunnelMapElements({
    funnelMap,
    visibilityMap: DEFAULT_VISIBILITY_MAP,
    objectTypesByName: {},
    crmOrgs: crmOrgs,
  });
  const nodesLength = sweepNodes.length + sweepStandaloneNodes.length;

  return (
    <PreviewContainer sx={sxProps} data-testid="funnel-preview">
      {nodesLength > 0 && (
        <div style={{ width: '100%', height: '100%' }}>
          <SweepCanvas
            sweepGroups={sweepGroups}
            sweepNodes={sweepNodes}
            sweepEdges={sweepEdges}
            sweepStandaloneNodes={sweepStandaloneNodes}
            sweepSections={sweepSections}
            sweepStickyNotesNodes={sweepStickyNotesNodes}
            sweepTextNodes={sweepTextNodes}
            canvasMode={canvasMode ?? CanvasMode.PREVIEW1}
            showPreviewBackground={showPreviewBackground}
            fitViewTimeoutValue={fitViewTimeoutValue}
            visibilityMap={DEFAULT_VISIBILITY_MAP}
            onConnectClick={noop}
            readonly
          />
        </div>
      )}
    </PreviewContainer>
  );
};
